export const generateMind = async (imageTargets) => {
    const exportedBuffer = await compileImages(imageTargets)
    return new Blob([exportedBuffer])
}

export const compileImages = async (images, progressMonitor) => {
    const { IMAGE: mindarImage } = window.MINDAR
    const compiler = new mindarImage.Compiler()
    const monitor = progressMonitor ?? console.log

    const filtered = []
    const unique = {}
    for (const image of images) {
        console.log(
            `image ${image.src} [w: ${image.clientWidth}, h: ${image.clientHeight}]`
        )

        if (image.clientWidth > 0 && !unique[image.src]) {
            filtered.push(image)
            unique[image.src] = true
        }
    }

    await compiler.compileImageTargets(filtered, monitor)
    console.log('%s targets were compiled', filtered.length)

    const exportedBuffer = await compiler.exportData()
    console.log('Targets were exported')

    return exportedBuffer
}
